"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SkipToNext15Sec = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_SkipToNext15Sec_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.113.146a.5.5 0 1 0-.707.708L11.053 2.5H6.75a6.75 6.75 0 1 0 0 13.5H7a.5.5 0 0 0 0-1h-.25a5.75 5.75 0 0 1 0-11.5h4.303L9.406 5.146a.5.5 0 0 0 .707.707l2.5-2.5a.5.5 0 0 0 0-.707l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.354.146a.5.5 0 0 0-.708.708L14.793 3l-2.147 2.146a.5.5 0 0 0 .708.707l2.5-2.5a.5.5 0 0 0 0-.707l-2.5-2.5ZM8.876 16h1.262V7H9.051L6.8 9.162l.7.775.837-.774c.142-.134.259-.25.35-.35.092-.1.171-.192.238-.276l-.025.538-.025.55V16ZM14.863 10.662c-.359-.225-.78-.337-1.263-.337-.183 0-.367.013-.55.038a3.465 3.465 0 0 0-.513.087l.175-2.375h2.763L15.457 7h-3.838l-.269 4.188.513.4a3.97 3.97 0 0 1 .6-.138c.225-.042.433-.063.625-.063.541 0 .95.142 1.225.425.274.284.412.696.412 1.238 0 .367-.067.692-.2.975a1.462 1.462 0 0 1-.563.662c-.241.15-.541.226-.9.226a3.49 3.49 0 0 1-.95-.138c-.316-.1-.608-.23-.874-.388v1.188c.241.142.52.246.837.313a4.56 4.56 0 0 0 1.05.112c.625 0 1.15-.12 1.575-.363.425-.25.746-.6.963-1.05.224-.458.337-.991.337-1.6 0-.541-.1-1.008-.3-1.4a2.1 2.1 0 0 0-.837-.925Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_SkipToNext15Sec_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = SkipToNext15Sec;
exports["default"] = _default;